var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content text-center" }, [
      _c("img", { attrs: { src: "logo.png", width: "200px" } }),
      _vm._v(" "),
      _c("iframe", {
        attrs: {
          id: "framed",
          src: "frame.html",
          frameborder: "0",
          scrolling: "no"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }